/**
 * Access gate for the GA features: FutureBot, Mortgage Monitor,
 * Leaderboard, and the Daily Briefing.
 *
 * Open to every CRM user (CRMUser === true) plus SuperAdmins / CRM Admins.
 * Non-CRM Hub users (EOS-only staff, etc.) stay locked out — matches the
 * Sidebar's CRM accordion gate and the backend assertCrmUser /
 * assertNewFeatureUser checks in functions/CRM/utils/callerRoles.js.
 */

export function canAccessNewFeatures({ currentUser, SuperAdmin, Roles } = {}) {
  // External demo accounts (partner test drives) are CRM users but must NOT
  // see company-wide surfaces: Leaderboard, Mortgage Monitor, FutureBot, and
  // the Daily Briefing all show real company data. Strictly opt-in flag —
  // regular users (field absent) are unaffected. See src/utils/demoAccess.js.
  if (currentUser?.externalDemo === true) return false;
  return (
    currentUser?.CRMUser === true ||
    SuperAdmin === true ||
    currentUser?.SuperAdmin === true ||
    currentUser?.CRMRole === 'CRM Admin' ||
    (Array.isArray(Roles) && Roles.includes('CRM Admin')) ||
    (Array.isArray(currentUser?.Roles) && currentUser.Roles.includes('CRM Admin'))
  );
}
